import Vue from "vue"
import store from "@/store"
import ResizeObserver from "resize-observer-polyfill";

Vue.directive('has', {
    inserted: function (el, binding, vnode) {
        // 获取指令按钮权限
        if(["mock"].indexOf(process.env.VUE_APP_MODE) > -1 ) return
        let permission = binding.value;
        if(store.getters.permissionButtons.indexOf(permission) === -1 && store.getters.permissionMenus.indexOf(permission) === -1 ){
            el.parentNode.removeChild(el);
        }
    }
})

Vue.directive("resize", { // 指令的名称

    bind(el, binding) { // el为绑定的元素，binding为绑定给指令的对象
        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                binding.value(entry.contentRect, entry.target);
            }
        });
        resizeObserver.observe(el)
    },
    unbind(el) {

    }
})

// 防止el-button重复点击
Vue.directive("preventReClick", {
    // 指令的定义
    inserted(el, binding) {
        el.addEventListener('click', () => {
            if (!el.disabled) {
                el.disabled = true
                setTimeout(() => {
                    el.disabled = false
                }, binding.value || 2000)
            }
        })
    }
})